var map = {
	"./assemble-bake/assemble-bake_01.jpg": 5843,
	"./assemble-bake/assemble-bake_02.jpg": 6095,
	"./assemble-bake/assemble-bake_03.jpg": 1941,
	"./make-dough/make-dough_01.jpg": 9217,
	"./make-dough/make-dough_02.jpg": 2710,
	"./make-dough/make-dough_03.jpg": 3617,
	"./spread-dough/spread-dough_01.jpg": 5319,
	"./spread-dough/spread-dough_02.jpg": 4311,
	"./spread-dough/spread-dough_03.jpg": 3323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5419;